import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'cc-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0.5, transform: 'translateY(-10px)' }),
        animate(200, style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class InputErrorComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() inputIndex: number;
  @Input() inputName: string;
  @Input() error: string;
  @Input() text: string;

  constructor() {}

  ngOnInit() {}
}
